import React, { useEffect, useState } from 'react'
import TabNavigation from '../../../../partials/TabsContainer/TabNavigation'
import TabContent from '../../../../partials/TabsContainer/TabContent'
import TabItem from '../../../../partials/TabsContainer/TabItem'
import Media from '../../../../partials/Media'
import Button from "../../../../partials/Button"

import "../../../../partials/TabsContainer/Tabs.scss"
import HTMLContent from '../../../../partials/HTMLContent'

const Tabs = (props) => {

    const { data, className, selectedIndex=0, nextView, onSelect, onComplete, children } = props
    const [ currentStep, setCurrentStep ] = useState()
    const [ viewedContent, setViewedContent ] = useState()

    useEffect(() => {

        if(!currentStep && data){
            setCurrentStep(selectedIndex)
            // setViewedContent(modifyArray(data, data[0]))
        } 
        
    }, [viewedContent]) 
    
    const modifyArray = (arr, obj) => (arr.map(item =>
        item.name === obj.name
            ? { ...item, viewed: true }
            : item
    ))

    const onSelectHandle = (selected, index) => {

        setCurrentStep(index)
        // setViewedContent(modifyArray(viewedContent, selected))
        if(onSelect) onSelect(index)
    }

     const areTheyViewed = (arr) => {
        return arr ? arr.every((item) => item.viewed === true) : false
    }

    return (
        <>
                <div className={`tabs-container ${className}`}>

                    <TabNavigation data={data} selected={selectedIndex} onSelectHandle={onSelectHandle} />

                    <TabContent className="tabs-content">

                        {!children && data.map((item, index) => {
                            
                            const selected = index===currentStep
                            
                            return (
                                <TabItem key={index} className='flex' selected={selected}>
                                    
                                    {item.media && 
                                            <div className="tabs-container-column media">
                                                <Media data={item.media} />                   
                                            </div>
                                        }

                                        {item.content &&
                                            <div className="tabs-container-column">

                                                <HTMLContent >
                                                    <h2>{item.name}</h2>
                                                    {
                                                        item.content.map((content, index) => (
                                                            <div key={index}>
                                                                <h3>{content.header}</h3>
                                                                <p>{content.paragraph}</p>
                                                            </div>
                                                        ))
                                                    }

                                                    

                                                </HTMLContent>
                                                <Button 
                                                        className="small primary" 
                                                        // disabled={!areTheyViewed(viewedContent)} 
                                                        text="continue" 
                                                        onClick={() => onComplete(nextView)}/>
                                            </div>
                                        }
                                        
                                </TabItem>
                            )
                        })}

                        
                        {children}
                        
                    </TabContent>
                </div>
        </>
    );
}

export default Tabs